import React, { useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { Tooltip, IconButton, TextField, InputAdornment } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { CSSTransition } from 'react-transition-group';
import './TextField.css';

export default function SearchInput({ children, handleSearchString, setMargin }) {
  const [showInput, setShowInput] = useState(false);

  const handleClick = () => {
    setShowInput(true);
  };

  const handleSearch = (e) => {
    handleSearchString(e.target.value.toUpperCase());
  };

  const handleClear = () => {
    setShowInput(false);
    handleSearchString('');
  };

  return (
    <div>
      <span
        className="p-1 flex-grow-1"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        {children}

        <div style={{margin: setMargin != null ? setMargin : 10}}>
          {!showInput && (
            <Tooltip title="Søk">
              <IconButton onClick={handleClick} color="primary">
                <SearchIcon />
              </IconButton>
            </Tooltip>
          )}
          <CSSTransition
            in={showInput}
            timeout={300}
            classNames="slide"
            unmountOnExit
          >
            <div className="text-field-container">
              {showInput && (
                <div className="text-field">
                  <TextField
                    id="outlined-basic"
                    label="Søk"
                    variant="outlined"
                    size="small"
                    onChange={handleSearch}
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <ClearIcon onClick={handleClear} />
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      '& .MuiInputAdornment-root': {
                        color: '#1976d2',
                      },
                      '& .MuiFormLabel-root': {
                        color: '#1976d2',
                      },
                      '& .MuiInputBase-input': {
                        color: 'black',
                      },
                    }}
                  />
                </div>
              )}
            </div>
          </CSSTransition>
        </div>
      </span>
    </div>
  );
}
